import { motion } from "framer-motion"
import { graphql, Link, useStaticQuery } from "gatsby"
import React from "react"
import Layout from "../components/layout"

const NotFoundPage = props => {

  const data = useStaticQuery(graphql`
  query {
    wp {
      fluxDnaSettings {
        fluxDna {
          fourDescription
          fourHeading
        }
      }
    }
  }
`)
  const pageData = data.wp.fluxDnaSettings.fluxDna;

  const animationVariants = {
    hidden: {
      opacity: 0,
      y: 20,
    },
    visible: {
      opacity: 1,
      y: 0,
    },
  }
  return (
    <div className="fullPageanimation">
      <Layout props={props}>
        <section className="banner--wapper">
          <div
            className="h-[88px] smscreen2:h-[89px] opacity-0"
            aria-label="Kova"
          >
            Kove
          </div>
          <div
            className={`banner half-banner relative bg-stone ${module.extraClass ? `${module.extraClass}` : ""
              }`}
            id={module.extraId}
          >
            <div className="container-fluid h-full">
              <div className="banner-inner relative h-full">
                <div className="desk-img h-full mdscreen:h-full relative ">
                  <img
                    src="../../../images/Hero.webp"
                    className="w-full h-full object-cover"
                    width={1440}
                    height={552}
                    loading="eager"
                    alt="404"
                  />
                </div>
                <div className="absolute bottom-0 pb-120 lgscreen:pb-50 z-10 text-center w-full px-30">
                  <motion.div
                    initial="hidden"
                    animate="visible"
                    variants={animationVariants}
                    transition={{ duration: 0.5, delay: 0.5 }}
                    className="title-white"
                  >
                    <h1>{pageData.fourHeading}</h1>
                  </motion.div>
                  <div class="content white w-full max-w-[800px] mx-auto">
                    <motion.p
                      initial="hidden"
                      animate="visible"
                      variants={animationVariants}
                      transition={{ duration: 0.5, delay: 1 }}
                    >
                      {pageData.fourDescription}
                    </motion.p>
                  </div>
                  <motion.div
                    initial="hidden"
                    animate="visible"
                    variants={animationVariants}
                    transition={{ duration: 0.5, delay: 1.5 }}
                    className="mt-25 lgscreen:mt-20"
                  >
                    <Link target="" className="btn btn-transparent" to="/">
                      go to home
                    </Link>
                  </motion.div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Layout>
    </div>
  )
}

export default NotFoundPage
